import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useResetPassword = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [resetPasswordLoading, setResetPasswordLoading] = useState(false);

  const resetPasswordRequest = ({ guid, password, onSuccess }) => {
    setResetPasswordLoading(true);
    axiosClient
      .put(`SettingAccount/User/ResetPassword`, { guid, password })

      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`رمز عبور با موفقیت تغییر کرد`, {
            variant: 'success',
          });
          onSuccess?.();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setResetPasswordLoading(false));
  };
  return { resetPasswordRequest, resetPasswordLoading };
};

export default useResetPassword;
